<script lang="ts" setup>
import { countries } from '@thecompaniesapi/shared/client'

const props = defineProps({
  modelValue: {
    default: '',
    type: String,
  },
  showAll: {
    default: false,
    type: Boolean,
  },
  size: {
    default: 'sm',
    type: String as PropType<UInputSize>,
  },
})

const emit = defineEmits<{
  'update:modelValue': [modelValue: string]
}>()

const { locale, t } = useI18n()

const countryOptions = computed(() => {
  const options = countries
    .slice()
    .sort((countryA) => {
      const mostUsed = [
        'fr',
        'us',
        'gb',
        'de',
        'es',
        'it',
        'nl',
        'be',
        'ch',
        'ca',
      ]

      return mostUsed.includes(countryA.code) ? -1 : 1
    })
    .map(
      country => ({
        icon: `flagpack:${country.code}`,
        label: country.name[(locale.value || 'en') as Locale] as string,
        value: country.code,
      }),
    )

  if (props.showAll) {
    options.push({
      icon: getIcon('flag'),
      label: t('allCountries'),
      value: 'all',
    })
  }

  return options
})

const innerValue = computed({
  get() {
    return props.modelValue || ''
  },

  set(value: string) {
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <USelectMenu
    v-model="innerValue"
    :icon="modelValue && modelValue !== 'all' ? `flagpack:${modelValue}` : getIcon('flag')"
    :options="countryOptions"
    :placeholder="t('chooseCountry')"
    searchable
    :size="size"
    value-attribute="value"
  />
</template>

<i18n lang="json">
{
  "en": {
    "allCountries": "All countries",
    "chooseCountry": "Choose a country"
  },
  "es": {
    "allCountries": "Todos los países",
    "chooseCountry": "Elige un país"
  },
  "fr": {
    "allCountries": "Tous les pays",
    "chooseCountry": "Choisissez un pays"
  }
}
</i18n>
